require('./brokerMarketsLastNewsDetailView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { Link } = require('react-router-dom');
const { withRouter } = require('react-router-dom');

const moment = require('moment');

// @components
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKBoxSectionContent } = require('commonsComponents/OKBoxSectionContent');
const { OKBoxNewPreview } = require('commonsComponents/OKBoxNewPreview');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const OKLoadingErrorMessage = require('components/commons/OKLoadingErrorMessage/OKLoadingErrorMessage');

// @actions
const brokerMarketsActions = require('actions/brokerMarkets');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { getFirstNWords } = require('utilities/stringHelper');

class BrokerMarketsLastNewsDetailView extends React.Component {

    componentDidMount() {
        const { immBrokerMarket, requestLastNews, requestBodyLastNews, match: { params } } = this.props;
        const lastNewContent = immBrokerMarket.get('news').size > 0 ? immBrokerMarket.get('news').toJS() : null;
        const financesDetail = lastNewContent && lastNewContent[params.idNew];

        if (!financesDetail)
            requestBodyLastNews(params.idNew);
        if (immBrokerMarket.get('lastNews').length === 0)
            requestLastNews();
    }

    componentDidUpdate(prevProps) {
        const { requestBodyLastNews, match: { params } } = this.props;
        if (params.idNew !== prevProps.match.params.idNew) {
            requestBodyLastNews(params.idNew);
        }
    }

    buildBreadCrumb = () => {
        const { immBrokerMarket, match: { params } } = this.props;
        const lastNewContent = immBrokerMarket.get('news').size > 0 ? immBrokerMarket.get('news').toJS() : null;
        const lastNewsDetail = lastNewContent && lastNewContent[params.idNew]
        const getFirstWords = lastNewsDetail ? getFirstNWords(lastNewsDetail.title) : '';

        return (
            [
                {
                    text: <FormattedText value="brokerMarketNews-savingsTitlte" />,
                    url: '/myprofile/broker'
                },
                {
                    text: <FormattedText value="broker-marketsTitle" />,
                    url: '/myprofile/broker/markets'
                },
                {
                    text: <FormattedText value="brokerMarketNews-lastNewsTitle" />,
                    url: '/myprofile/broker/markets/last-news'
                },
                {
                    text: getFirstWords,
                    url: ''
                }
            ]
        )
    }

    buildContentNew = () => {
        const { immBrokerMarket, match: { params } } = this.props;
        const lastNewContent = immBrokerMarket.get('news').size > 0 ? immBrokerMarket.get('news').toJS() : null;
        const financesDetail = lastNewContent && lastNewContent[params.idNew];

        if (financesDetail && lastNewContent) {
            const textWithoutOriginTags = financesDetail.body.replace(/<[\/]{0}(Origin|ORIGIN|origin)[^><]*>(.*?)<[\/]{1}(Origin|ORIGIN|origin)[^><]*>/g, "");
            const textHasParagraphTags = financesDetail.body.includes("<p>");

            let textValue;
            if (!textHasParagraphTags) {
                const textWithoutPreTags = textWithoutOriginTags.replace(/(?:^|<\/pre>)[^]*?(?:<pre>|$)/g, "");
                const textWithoutBreaks = textWithoutPreTags.split(/(\n)\1{1,}|\n\s{3,}/g).filter(n => n);
                textValue = textWithoutBreaks
                    .map((text, index) => !!text && <HTMLSafeInjector key={`paragraph-${index}`} message={text.replace("/n", " ")} />);
            } else {
                textValue = <HTMLSafeInjector message={textWithoutOriginTags} />
            }

            return (
                <div className="broker-markets-last-news-detail__body">
                    <span className="date">{moment(financesDetail.newsDate).format('DD MMM YYYY - hh:mm')}</span>
                    <h1 className="title">{financesDetail.title}</h1>
                    <div className="content">
                        {textValue}
                    </div>
                </div>
            )
        }
    }

    buildOtherNewsSection = () => {
        const { immBrokerMarket, match: { params } } = this.props;
        const otherLastNews = immBrokerMarket.get('lastNews');

        const grid = otherLastNews
            .filter(f => f.urn !== params.idNew).slice(0, 3).map((news, index) => (
                <div className="col-xs-4" key={`other-news-${index.toString()}`}>
                    <div className="box-news-content">
                        <OKBoxNewPreview
                            title={news.title}
                            date={
                                <div className="broker-markets-last-news-detail__date-other-news">
                                    <i className="broker-markets-last-news-detail__icon-bookmark icon icon-bookmark" />
                                    {moment(news.newsDate).format('DD MMM YYYY - hh:mm')}
                                </div>
                            }
                            linkContent={
                                <Link to={`/myprofile/broker/markets/last-news-detail/${news.urn}`}>
                                    <FormattedText value="brokerMarketNews-readMoreNews" />
                                </Link>
                            }
                        />
                    </div>
                </div>
            )
            )

        return grid;

    }

    buildNewsSections = (type) => {
        const { immBrokerMarket } = this.props;
        const loading = immBrokerMarket.get('fetchingLastNews');
        const error = immBrokerMarket.get('errorLastNews');

        return (
            <OKLoadingErrorMessage
                isLoading={loading}
                isError={error}
            >
                {type === 'detailNew' ? this.buildContentNew() : this.buildOtherNewsSection()}
            </OKLoadingErrorMessage>
        );
    }

    render() {
        const contentNew = this.buildNewsSections('detailNew');
        const otherNewsGrid = this.buildNewsSections('otherNews');

        return (
            <div className="broker-markets-last-news-detail">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={this.buildBreadCrumb()}
                                finalTitle={<FormattedText value="brokerMarketNews-lastNewsTitle" />}
                            >
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>

                    <div className="grid-view__body">
                        <div className="container-fluidzzz">
                            <div className="broker-markets-last-news-detail__container">
                                <div>
                                    <OKBoxSectionContent
                                        content={contentNew}
                                        hasFooter
                                        footerContentLeft={
                                            <Link to="/myprofile/broker/markets/last-news">
                                                <FormattedText value="brokerMarketNews-returnLastNews" />
                                            </Link>
                                        }
                                    />
                                </div>
                            </div>
                            <div className="broker-markets-last-news-detail__other-news-section">
                                <OKBoxSectionContent
                                    title={<FormattedText value="brokerMarketNews-otherNewsTitle" />}
                                    className="row"
                                    content={otherNewsGrid}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerMarketsLastNewsDetailView.propTypes = {
    immBrokerMarket: PropTypes.object,
    match: PropTypes.object,
    requestLastNews: PropTypes.func,
    requestBodyLastNews: PropTypes.func
};

module.exports.constructor = BrokerMarketsLastNewsDetailView;
module.exports.BrokerMarketsLastNewsDetailView = withRouter(connect(
    state => ({
        immBrokerMarket: state.brokerMarkets
    }), {
    requestLastNews: brokerMarketsActions.requestLastNews,
    requestBodyLastNews: brokerMarketsActions.requestBodyLastNews
})(BrokerMarketsLastNewsDetailView));
